import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import employment from './images/employment.png'

const EmploymentVerification = props => {
  const { t } = useTranslation()
  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.employment_verification.title', 'Employment Verification'),
          description: (
            <Trans i18nKey="b.liv_score.view.employment_verification.text">
              <strong>Employment Verification</strong> has renters submit additional documentation
              (e.g. T4, business card, job offer letter, or pay stub) that confirms their stated
              employment. The liv.rent team then checks this against the user's profile to ensure a
              match.`
            </Trans>
          ),
          image: employment
        })
      }
    />
  )
}

export default EmploymentVerification
